(function () {
  /* Hex values for Spanish color names. Se leen de snippets/wc-color-dict.liquid
     vía el <script type="application/json" id="wc-color-dict-json"> que
     layout/theme.liquid renderiza una vez por página (render 'wc-color-dict',
     as_json: true) — ya no hay copia hardcodeada aquí. Si el tag no está
     presente (defensivo), MAP queda vacío y todo cae al fallback hslFromName;
     ningún swatch se queda sin pintar. */
  var MAP = (function () {
    var el = document.getElementById('wc-color-dict-json');
    var map = {};
    if (!el) return map;
    try {
      var pairs = JSON.parse(el.textContent);
      pairs.forEach(function (entry) {
        var i = entry.indexOf(':');
        if (i === -1) return;
        map[entry.slice(0, i)] = entry.slice(i + 1);
      });
    } catch (e) { /* map queda vacío, hslFromName cubre el resto */ }
    return map;
  })();

  /* Normalize a color name: lowercase, strip accents, unify separators. */
  function normalize(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[-_]/g, ' ')
      .trim();
  }

  /* Look up a hex for a normalized color name: exact key first, then the
     longest substring match (so "azul cielo" prefers that specific key
     over the shorter, more generic "azul"). */
  function lookupHex(colorName) {
    if (MAP[colorName]) return MAP[colorName];
    var bestKey = null;
    for (var key in MAP) {
      if (colorName.indexOf(key) !== -1 && (!bestKey || key.length > bestKey.length)) {
        bestKey = key;
      }
    }
    return bestKey ? MAP[bestKey] : null;
  }

  /* Apply --swatch--background to every swatch element that doesn't already
     have a color set. La mayoría de los swatches de la PDP y el selector de
     variantes ya llegan coloreados desde el servidor (ver wc-color-hex.liquid
     + product-variant-options.liquid) — esta función es solo la red de
     seguridad para el resto (facetas de PLP, nombres de color fuera del
     diccionario, etc.), y nunca deja un círculo vacío: si no hay match en el
     diccionario, usa un color determinístico por hash del nombre. */
  function colorize(root) {
    (root || document).querySelectorAll('.swatch').forEach(function (swatch) {
      /* Skip swatches that already have an explicit background set. */
      if (swatch.style.getPropertyValue('--swatch--background')) return;

      var titled = swatch.closest('[title]');
      if (!titled) return;
      var colorName = normalize(titled.getAttribute('title'));
      if (!colorName) return;

      var color = lookupHex(colorName) || hslFromName(colorName);
      swatch.style.setProperty('--swatch--background', color);
    });
  }

  /* Re-run whenever new swatch elements are injected into the DOM
     (Dawn re-renders the variant picker on variant change, and replaces
     the PLP sidebar facets markup wholesale when a filter is applied). */
  /* Debounced: durante los reemplazos de innerHTML del PLP AJAX llegan
     decenas de batches seguidos; sin esto se re-ejecutaban los inits
     globales por cada batch (trabajo redundante sobre document.body). */
  var observerTimer = null;
  var observer = new MutationObserver(function (mutations) {
    var hasAddedElement = false;
    for (var i = 0; i < mutations.length && !hasAddedElement; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) {
          hasAddedElement = true;
          break;
        }
      }
    }
    if (!hasAddedElement) return;
    clearTimeout(observerTimer);
    observerTimer = setTimeout(function () {
      colorize(document);
      initSidebarColorSwatches();
      initCatalogoColorSwatches();
      initCardSwatches();
    }, 80);
  });

  /* Deterministic HSL hue from a normalized color name.
     Never produces gray (S=65%, L=50% — always a saturated color). */
  function hslFromName(name) {
    var h = 0;
    for (var i = 0; i < name.length; i++) {
      h = (h * 31 + name.charCodeAt(i)) & 0xffff;
    }
    return 'hsl(' + (h % 360) + ',65%,50%)';
  }

  /* Paint color swatches for /collections/catalogo with HSL fallback so
     no color ever renders as the generic gray default. Does NOT modify
     initSidebarColorSwatches() which handles /collections/waycup. */
  function initCatalogoColorSwatches() {
    if (!document.querySelector('.wc-plp-catalogo')) return;
    document.querySelectorAll(
      '.wc-plp-catalogo .facets__display-vertical[data-label="color"] .facet-checkbox'
    ).forEach(function (label) {
      var textEl = label.querySelector('.facet-checkbox__text-label');
      if (!textEl) return;
      var colorName = normalize(textEl.textContent);
      var hex = lookupHex(colorName);
      label.style.setProperty('--swatch-color', hex || hslFromName(colorName));
    });
  }

  /* Paint circular color swatches in the PLP sidebar facets filter.
     Finds the "Color" facet group via its data-label attribute (set by
     Liquid from the raw Shopify filter label, same hook the CSS circle
     styling already keys off), sets --swatch-color on each label so the
     CSS circle reflects the actual color — con el mismo respaldo
     determinístico que el resto, para que ningún círculo quede gris. */
  function initSidebarColorSwatches() {
    document.querySelectorAll('.wc-plp-sidebar .facets__display-vertical[data-label="color"]').forEach(function (display) {
      display.querySelectorAll('.facet-checkbox').forEach(function (label) {
        var textEl = label.querySelector('.facet-checkbox__text-label');
        if (!textEl) return;
        var colorName = normalize(textEl.textContent);
        var hex = lookupHex(colorName) || hslFromName(colorName);
        label.style.setProperty('--swatch-color', hex);
      });
    });
  }

  /* Paint PLP card swatches (.wc-product-card__swatch) whose color the
     server couldn't resolve: card-product.liquid emits an inline background
     from wc-color-dict when the name matches; anything left transparent
     here gets the same lookup + deterministic HSL fallback as the facets,
     so no card circle ever renders empty. */
  function initCardSwatches() {
    document.querySelectorAll('.wc-product-card__swatch[title]').forEach(function (swatch) {
      if (swatch.style.background) return; /* ya resuelto en servidor */
      var colorName = normalize(swatch.getAttribute('title'));
      if (!colorName) return;
      swatch.style.background = lookupHex(colorName) || hslFromName(colorName);
    });
  }

  function init() {
    colorize(document);
    initSidebarColorSwatches();
    initCatalogoColorSwatches();
    initCardSwatches();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
